function parseVisitorData() {
  const container = document.getElementById('visitor-data');
  if (!container) return null;
  try {
    const raw = container.textContent.trim();
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error('No se pudo parsear la información del visitante', error);
    return null;
  }
}

function parseSiteConfig() {
  const container = document.getElementById('site-config-data');
  if (!container) return {};
  try {
    const raw = container.textContent.trim();
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.warn('No se pudo parsear la configuración del sitio', error);
    return {};
  }
}

async function fetchImageBytes(url) {
  const response = await fetch(url, { mode: 'cors' });
  if (!response.ok) {
    throw new Error(`No se pudo descargar el recurso (${response.status})`);
  }
  const arrayBuffer = await response.arrayBuffer();
  return new Uint8Array(arrayBuffer);
}

function updateTextContent(element, value) {
  if (!element) return;
  element.textContent = value && value.length ? value : '—';
}

function updateStatus(statusEl, { message, variant }) {
  if (!statusEl) return;
  statusEl.textContent = message;
  statusEl.classList.remove('text-muted', 'text-danger', 'text-success');
  statusEl.classList.add(variant || 'text-muted');
}

function confirmWithSweetAlert({
  message,
  title = 'Confirmar acción',
  icon = 'warning',
  confirmButtonText = 'Sí',
  cancelButtonText = 'Cancelar'
}) {
  if (window.Swal) {
    return window.Swal
      .fire({
        icon,
        title,
        text: message,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        focusCancel: true
      })
      .then((result) => result.isConfirmed);
  }

  return Promise.resolve(window.confirm(message));
}

async function downloadVisitorPdf(visitor) {
  if (!window.PDFLib || !window.QRious) {
    throw new Error('Librerías de QR o PDF no disponibles');
  }

  const { PDFDocument, StandardFonts } = window.PDFLib;
  const siteConfig = parseSiteConfig();
  const pdfDoc = await PDFDocument.create();
  const page = pdfDoc.addPage();
  const { width, height } = page.getSize();
  const margin = 50;

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  let cursorY = height - margin;

  if (siteConfig?.navbarLogoUrl) {
    try {
      const logoBytes = await fetchImageBytes(siteConfig.navbarLogoUrl);
      let logoImage;
      try {
        logoImage = await pdfDoc.embedPng(logoBytes);
      } catch (err) {
        logoImage = await pdfDoc.embedJpg(logoBytes);
      }
      const maxLogoWidth = 140;
      const scaled = logoImage.scale(Math.min(1, maxLogoWidth / logoImage.width));
      const logoX = (width - scaled.width) / 2;
      const logoY = cursorY - scaled.height;
      page.drawImage(logoImage, {
        x: logoX,
        y: logoY,
        width: scaled.width,
        height: scaled.height
      });
      cursorY = logoY - 16;
    } catch (logoError) {
      console.warn('No se pudo incorporar el logo al PDF:', logoError);
    }
  }

  if (siteConfig?.siteName) {
    const siteName = siteConfig.siteName;
    const siteNameSize = 14;
    const siteNameWidth = fontBold.widthOfTextAtSize(siteName, siteNameSize);
    page.drawText(siteName, {
      x: (width - siteNameWidth) / 2,
      y: cursorY,
      size: siteNameSize,
      font: fontBold
    });
    cursorY -= 24;
  }

  const title = 'Registro de visitante';
  const titleWidth = fontBold.widthOfTextAtSize(title, 20);
  page.drawText(title, {
    x: (width - titleWidth) / 2,
    y: cursorY,
    size: 20,
    font: fontBold
  });

  cursorY -= 36;

  const details = [
    ['Nombre', visitor.name],
    ['Motivo', visitor.reasonDisplay || visitor.reason],
    ['Estado', visitor.statusDisplay || visitor.statusCurrent || visitor.status],
    ['Fecha de la visita', visitor.visitDateDisplay || visitor.visitDate],
    ['Hora estimada', visitor.estimatedTimeDisplay || visitor.estimatedTime],
    ['Tipo de vehículo', visitor.vehicleTypeDisplay || visitor.vehicleType],
    ['Placas', visitor.licensePlate || '—'],
    ['Residente responsable', visitor.residentName || '—'],
    ['Número de residencia', visitor.residenceNumber || '—'],
    ['Registrado por', visitor.createdByEmail || '—'],
    ['Identificador QR', visitor.qrCodeValue || '—']
  ];

  details.forEach(([label, value]) => {
    const text = `${label}: ${value ?? '—'}`;
    page.drawText(text, {
      x: margin,
      y: cursorY,
      size: 12,
      font
    });
    cursorY -= 18;
  });

  cursorY -= 20;

  if (!visitor.qrCodeValue) {
    throw new Error('El código QR no está disponible.');
  }

  const qr = new window.QRious({
    value: visitor.qrCodeValue,
    level: 'H',
    size: 300,
    padding: 0
  });
  const qrDataUrl = qr.toDataURL();
  const qrBase64 = qrDataUrl.replace(/^data:image\/png;base64,/, '');
  const qrImage = await pdfDoc.embedPng(qrBase64);
  const qrSize = 200;
  const qrX = (width - qrSize) / 2;
  const qrY = Math.max(margin, cursorY - qrSize);

  page.drawImage(qrImage, {
    x: qrX,
    y: qrY,
    width: qrSize,
    height: qrSize
  });

  const generatedLabel = visitor.qrGeneratedAtDisplay
    ? `QR generado el ${visitor.qrGeneratedAtDisplay}`
    : 'QR generado recientemente';

  page.drawText(generatedLabel, {
    x: margin,
    y: qrY - 24,
    size: 12,
    font
  });

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `visitante-${visitor.id}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function initVisitorShowPage() {
  const statusEl = document.getElementById('qr-status');
  const button = document.getElementById('visitor-generate-qr');
  const codeEl = document.getElementById('visitor-qr-code');
  const generatedAtEl = document.getElementById('visitor-qr-generated-at');
  const statusValueEl = document.getElementById('visitor-status');
  const cameraVideo = document.getElementById('visitor-camera');
  const cameraToggleBtn = document.getElementById('visitor-camera-toggle');
  const idPreview = document.getElementById('visitor-id-preview');
  const platePreview = document.getElementById('visitor-plate-preview');
  const idCaptureBtn = document.getElementById('visitor-capture-id');
  const plateCaptureBtn = document.getElementById('visitor-capture-plate');
  const uploadPhotosBtn = document.getElementById('visitor-upload-photos');
  const photoStatusEl = document.getElementById('visitor-photo-status');
  const photosUploadedByEl = document.getElementById('visitor-photos-uploaded-by');
  const photosUploadedAtEl = document.getElementById('visitor-photos-uploaded-at');

  let visitor = parseVisitorData();
  if (!visitor) return;

  const ensureLibraries = () => Boolean(window.PDFLib && window.QRious);

  const setPhotoStatus = (message, variant = 'text-muted') => {
    if (!photoStatusEl) return;
    photoStatusEl.textContent = message;
    photoStatusEl.classList.remove('text-muted', 'text-success', 'text-danger');
    photoStatusEl.classList.add(variant);
  };

  const updatePreviewsFromVisitor = () => {
    if (idPreview) {
      if (visitor.idImageUrl) {
        idPreview.src = visitor.idImageUrl;
      } else {
        idPreview.removeAttribute('src');
      }
    }
    if (platePreview) {
      if (visitor.plateImageUrl) {
        platePreview.src = visitor.plateImageUrl;
      } else {
        platePreview.removeAttribute('src');
      }
    }
  };

  updatePreviewsFromVisitor();
  setPhotoStatus('Listo para capturar.');
  updateTextContent(photosUploadedByEl, visitor.photosUploadedBy || '—');
  updateTextContent(photosUploadedAtEl, visitor.photosUploadedAtDisplay || '—');

  let canCapture = (visitor.statusCurrent || visitor.status) === 'programado';

  const captureState = {
    idImage: null,
    plateImage: null
  };
  let mediaStream = null;
  const captureCanvas = document.createElement('canvas');

  const stopCamera = () => {
    if (mediaStream) {
      mediaStream.getTracks().forEach((track) => track.stop());
      mediaStream = null;
    }
    if (cameraVideo) {
      cameraVideo.srcObject = null;
    }
  };

  const setToggleState = (state) => {
    if (!cameraToggleBtn) return;
    cameraToggleBtn.dataset.state = state;
    if (state === 'on') {
      cameraToggleBtn.textContent = 'Apagar cámara';
      cameraToggleBtn.classList.remove('btn-outline-primary');
      cameraToggleBtn.classList.add('btn-outline-secondary');
    } else {
      cameraToggleBtn.textContent = 'Prender cámara';
      cameraToggleBtn.classList.remove('btn-outline-secondary');
      cameraToggleBtn.classList.add('btn-outline-primary');
    }
  };

  const updateCaptureControls = () => {
    if (canCapture) {
      cameraToggleBtn?.removeAttribute('disabled');
      idCaptureBtn?.removeAttribute('disabled');
      plateCaptureBtn?.removeAttribute('disabled');
      uploadPhotosBtn?.removeAttribute('disabled');
    } else {
      stopCamera();
      setToggleState('off');
      cameraToggleBtn?.setAttribute('disabled', 'disabled');
      idCaptureBtn?.setAttribute('disabled', 'disabled');
      plateCaptureBtn?.setAttribute('disabled', 'disabled');
      uploadPhotosBtn?.setAttribute('disabled', 'disabled');
    }
  };

  updateCaptureControls();

  if (!canCapture) {
    setPhotoStatus('No es posible capturar fotos porque el visitante ya no está programado.', 'text-danger');
  }

  const startCamera = async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
      setPhotoStatus('Este dispositivo no soporta acceso a la cámara.', 'text-danger');
      return null;
    }
    if (mediaStream) return mediaStream;
    try {
      mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }, audio: false });
      if (cameraVideo) {
        cameraVideo.srcObject = mediaStream;
      }
      setPhotoStatus('Cámara encendida.');
      return mediaStream;
    } catch (error) {
      console.error('No se pudo acceder a la cámara', error);
      setPhotoStatus('No se pudo acceder a la cámara. Revisa permisos.', 'text-danger');
      mediaStream = null;
      return null;
    }
  };

  setToggleState(cameraToggleBtn?.dataset.state === 'on' ? 'on' : 'off');

  cameraToggleBtn?.addEventListener('click', async () => {
    if (!canCapture) return;
    const isOn = cameraToggleBtn.dataset.state === 'on';
    if (isOn) {
      stopCamera();
      setToggleState('off');
      setPhotoStatus('Cámara apagada.');
    } else {
      const stream = await startCamera();
      if (stream) {
        setToggleState('on');
      }
    }
  });

  const captureFromCamera = async () => {
    if (!canCapture) return null;
    const stream = await startCamera();
    if (!stream || !cameraVideo) return null;
    if (!cameraVideo.videoWidth || !cameraVideo.videoHeight) {
      setPhotoStatus('Esperando a que la cámara esté lista…', 'text-warning');
      return null;
    }
    captureCanvas.width = cameraVideo.videoWidth;
    captureCanvas.height = cameraVideo.videoHeight;
    const ctx = captureCanvas.getContext('2d');
    if (!ctx) {
      setPhotoStatus('No se pudo procesar la imagen.', 'text-danger');
      return null;
    }
    ctx.drawImage(cameraVideo, 0, 0, captureCanvas.width, captureCanvas.height);
    return captureCanvas.toDataURL('image/jpeg', 0.9);
  };

  const handleCapture = async (key) => {
    if (!canCapture) return;
    const previewEl = key === 'id' ? idPreview : platePreview;
    if (!previewEl) return;
    const snapshot = await captureFromCamera();
    if (!snapshot) {
      setPhotoStatus('No se pudo capturar la imagen, intenta nuevamente.', 'text-danger');
      return;
    }
    previewEl.src = snapshot;
    captureState[key === 'id' ? 'idImage' : 'plateImage'] = snapshot;
    setPhotoStatus('Imagen capturada. Puedes guardar cuando tengas ambas.', 'text-success');
  };

  idCaptureBtn?.addEventListener('click', () => handleCapture('id'));
  plateCaptureBtn?.addEventListener('click', () => handleCapture('plate'));

  if (button) {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      if (!ensureLibraries()) {
        updateStatus(statusEl, {
          message: 'Cargando librerías para generar el PDF, intenta nuevamente en un momento…',
          variant: 'text-muted'
        });
        return;
      }

      try {
        button.disabled = true;
        updateStatus(statusEl, {
          message: 'Generando código QR…',
          variant: 'text-muted'
        });

        const response = await fetch(`/visitors/${visitor.id}/generate-qr`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'fetch'
          },
          credentials: 'same-origin'
        });

        if (!response.ok) {
          let errorMessage = 'No se pudo generar el QR, inténtalo de nuevo.';
          try {
            const errorPayload = await response.json();
            if (errorPayload?.error) errorMessage = errorPayload.error;
          } catch (err) {
            // Ignora errores de parseo y usa mensaje genérico.
          }
          throw new Error(errorMessage);
        }

        const payload = await response.json();
        if (!payload?.visitor) throw new Error('Respuesta inválida del servidor');

        visitor = payload.visitor;
        updateTextContent(codeEl, visitor.qrCodeValue);
        updateTextContent(generatedAtEl, visitor.qrGeneratedAtDisplay);
        updateTextContent(statusValueEl, visitor.statusDisplay || visitor.statusCurrent || visitor.status);

        await downloadVisitorPdf(visitor);

        updateStatus(statusEl, {
          message: 'Código QR generado y PDF descargado.',
          variant: 'text-success'
        });
      } catch (error) {
        console.error('Error generando el QR del visitante', error);
        updateStatus(statusEl, {
          message: error.message || 'No se pudo generar el QR, inténtalo nuevamente.',
          variant: 'text-danger'
        });
      } finally {
        button.disabled = false;
      }
    });
  }

  uploadPhotosBtn?.addEventListener('click', async () => {
    if (!canCapture) {
      setPhotoStatus('Este visitante ya no admite captura de fotos.', 'text-danger');
      return;
    }
    if (!captureState.idImage || !captureState.plateImage) {
      setPhotoStatus('Captura ambas fotos antes de guardar.', 'text-danger');
      return;
    }

    const confirmed = await confirmWithSweetAlert({
      message: '¿Deseas subir las fotos?',
      title: 'Confirmar carga',
      icon: 'question',
      confirmButtonText: 'Subir fotos'
    });
    if (!confirmed) return;

    try {
      uploadPhotosBtn.disabled = true;
      cameraToggleBtn?.setAttribute('disabled', 'disabled');
      setPhotoStatus('Subiendo fotos…', 'text-muted');

      const response = await fetch(`/visitors/${visitor.id}/upload-photos`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ idImage: captureState.idImage, plateImage: captureState.plateImage })
      });

      const payload = await response.json().catch(() => null);
      if (!response.ok || !payload?.ok) {
        const message = payload?.error || 'No se pudieron guardar las fotos.';
        setPhotoStatus(message, 'text-danger');
        return;
      }

      visitor = payload.visitor;
      updateTextContent(statusValueEl, visitor.statusDisplay || visitor.statusCurrent || visitor.status);
      updateTextContent(codeEl, visitor.qrCodeValue);
      updateTextContent(generatedAtEl, visitor.qrGeneratedAtDisplay);
      updatePreviewsFromVisitor();
      updateTextContent(photosUploadedByEl, visitor.photosUploadedBy || '—');
      updateTextContent(photosUploadedAtEl, visitor.photosUploadedAtDisplay || '—');
      captureState.idImage = null;
      captureState.plateImage = null;
      stopCamera();

      setPhotoStatus('Fotos subidas correctamente.', 'text-success');
      canCapture = (visitor.statusCurrent || visitor.status) === 'programado';
      updateCaptureControls();
      setToggleState('off');
    } catch (error) {
      console.error('Error subiendo fotos del visitante', error);
      setPhotoStatus('Ocurrió un error al subir las fotos.', 'text-danger');
    } finally {
      uploadPhotosBtn.disabled = false;
      updateCaptureControls();
      setToggleState('off');
    }
  });

  window.addEventListener('beforeunload', stopCamera);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopCamera();
      setToggleState('off');
    }
  });

  if (!canCapture) {
    cameraToggleBtn?.setAttribute('disabled', 'disabled');
    idCaptureBtn?.setAttribute('disabled', 'disabled');
    plateCaptureBtn?.setAttribute('disabled', 'disabled');
    uploadPhotosBtn?.setAttribute('disabled', 'disabled');
  }
}
